import { gql } from '@apollo/client';

export const GQL_GET_LANDING_PAGE_ANALYTICS = gql`
  query getLandingPageAnalytics($input: LandingPageAnalyticsInput!) {
    getLandingPageAnalytics(input: $input) {
      overview {
        sessions
        pageviews
        bounceRate
        avgDuration
      }
      series {
        date
        pageviews
        sessions
      }
      osBreakdown {
        name
        sessions
        pageviews
      }
      referrerBreakdown {
        name
        sessions
        pageviews
      }
      countryBreakdown {
        name
        sessions
        pageviews
      }
      cityBreakdown {
        name
        sessions
        pageviews
      }
      deviceBreakdown {
        name
        sessions
        pageviews
      }
      browserBreakdown {
        name
        sessions
        pageviews
      }
      errorMessage
    }
  }
`;
